import React from 'react';
import { companyListLoader } from '../../actions/data_loaders';
import withDataLoaded from '../with_data_loaded';
import PageSpinner from '../shared/page_spinner';
import CompanyList from './company_list';
import { useSelector } from 'react-redux';

function CompanyPage() {
  const companies = useSelector((redux) => [...redux.companyList].sort((a, b) => a['name'].localeCompare(b['name'])));

  return (
    <div className="admin-company-page">
      <CompanyList companies={companies} />
    </div>
  );
}

export default withDataLoaded({
  WithData: CompanyPage,
  WithoutData: PageSpinner,
  data: [companyListLoader],
});
